const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-summit-navy-dark text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img src="/summit-logo.png" alt="Summit MCG" className="h-20 w-20 mb-4" />
            <p className="text-sm text-gray-300">
              Specialist automotive consultancy and training designed to elevate dealership performance.
            </p>
          </div>
          
          <div>
            <h3 className="text-summit-gold font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-gray-300 hover:text-summit-gold transition-colors">Home</a></li>
              <li><a href="/about" className="text-gray-300 hover:text-summit-gold transition-colors">About</a></li>
              <li><a href="/services" className="text-gray-300 hover:text-summit-gold transition-colors">Services</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-summit-gold transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-summit-gold font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Email: Contact@summitmcg.co.uk</li>
              <li>WhatsApp: 07432 206 795</li>
              <li>Web: summitmcg.co.uk</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-summit-navy-light pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs text-gray-400">
            <div>
              <p className="mb-1">Summit Motor Consultancy Group Limited</p>
              <p className="mb-1">Company Number: 16917041</p>
              <p className="mb-1">Registered Office: 20 Wenlock Road, London, N1 7GU</p>
              <p>Registered in England & Wales</p>
            </div>
            <div className="md:text-right">
              <p>© {currentYear} Summit Motor Consultancy Group Limited. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;